export const TypesSlugsEnum = {

  // Type of Traking points
  RESERVATORIO: 'reservatorio',
  RASTREIO: 'rastreio',

  // Custom types
  FENOMENOS_TUMORAIS: "fenomenos-tumorais",
  FENOMENOS_VASCULARES: "fenomenos-vasculares",
  ESPACOS_POTENCIAIS: "espacos-potenciais",
  TIPOS_DE_FLUXO: "tipos-de-fluxo",
  OLIGOELEMENTOS: "oligoelementos",
  CHAKRAS: "chakras",
  CHROMOSOMES: "cromossomos",
  TERAPIAS_COMPLEMENTARES: 'terapias-complementares',

  // Types of Pares that are managed by the backend
  PARES_PSICOEMOCIONAIS: 'pares-psicoemocionais',
  ESPIRITUAIS_E_MALIGNOS: "espirituais-e-malignos",
  HORMONAIS: "hormonais",
  INTOXICACAO: "intoxicacaoenvenenamento",
  PARES_ESPECIAIS_NIVEL_1_2: "pares-especiais-nivel-1-e-2",
  HERPES_CHECAGEM: "herpes-checagem",
  SOFROLOGICO: "sofrologico",
  PROTOCOLO_BASICO: "protocolo-basico",
  MOVIMENTO_3D1_3D2: "movimento-3d1e-3d2",
  PROTOCOLO_LINFATICO: "protocolo-linfatico",
  PROTOCOLO_FSMI: "protocolo-fsmi",
  BIOMAGNETISCO_MEDICINAL: "biomagnetismo-medicinal",
  BIOMAGNETISMO_EMOCIONAL: "biomagnetismo-emocional",
  OLIGOELEMENT: 'oligoelementos',
}

export const TypesSlugsForSequence = [

  // Types of Pares that are used in the sequence
  TypesSlugsEnum.RESERVATORIO,
  TypesSlugsEnum.RASTREIO,
  TypesSlugsEnum.PARES_PSICOEMOCIONAIS,
  TypesSlugsEnum.ESPIRITUAIS_E_MALIGNOS,
  TypesSlugsEnum.HORMONAIS,
  TypesSlugsEnum.INTOXICACAO,
  TypesSlugsEnum.PARES_ESPECIAIS_NIVEL_1_2,
  TypesSlugsEnum.HERPES_CHECAGEM,
  TypesSlugsEnum.SOFROLOGICO,
  TypesSlugsEnum.PROTOCOLO_BASICO,
  TypesSlugsEnum.MOVIMENTO_3D1_3D2,
  TypesSlugsEnum.PROTOCOLO_LINFATICO,
  TypesSlugsEnum.PROTOCOLO_FSMI,
  TypesSlugsEnum.BIOMAGNETISCO_MEDICINAL,
  TypesSlugsEnum.BIOMAGNETISMO_EMOCIONAL,
  TypesSlugsEnum.OLIGOELEMENT,
  
  // Custom types that are used in the sequence
  TypesSlugsEnum.FENOMENOS_TUMORAIS,
  TypesSlugsEnum.FENOMENOS_VASCULARES,
  TypesSlugsEnum.ESPACOS_POTENCIAIS,
  TypesSlugsEnum.TIPOS_DE_FLUXO,
  TypesSlugsEnum.OLIGOELEMENTOS,
  TypesSlugsEnum.CHAKRAS,
  TypesSlugsEnum.CHROMOSOMES,
  TypesSlugsEnum.TERAPIAS_COMPLEMENTARES,
]

// Type of Traking points
export const TrakingPointTypeSlugs = [
  TypesSlugsEnum.RESERVATORIO,
  TypesSlugsEnum.RASTREIO,
]

export const isTrakingPointTypeSlug = (slug) => {
  return TrakingPointTypeSlugs.includes(slug);
}

// Custom types that are used in the sequence
export const CustomTypeSlugs = [
  TypesSlugsEnum.FENOMENOS_TUMORAIS,
  TypesSlugsEnum.FENOMENOS_VASCULARES,
  TypesSlugsEnum.ESPACOS_POTENCIAIS,
  TypesSlugsEnum.TIPOS_DE_FLUXO,
  TypesSlugsEnum.OLIGOELEMENTOS,
  TypesSlugsEnum.CHAKRAS,
  TypesSlugsEnum.CHROMOSOMES,
  TypesSlugsEnum.TERAPIAS_COMPLEMENTARES,
]

export const isCustomTypeSlug = (slug) => {
  return CustomTypeSlugs.includes(slug);
}

export const isAggregationApplicable = (slug) => {
  return !isCustomTypeSlug(slug) && !isTrakingPointTypeSlug(slug);
}